module.exports = __webpack_public_path__ + "static/Preferences-7543f784befcfe9fd8d29706fbacea8f.png";